import React from 'react';
import * as d3 from 'd3';
import { useI18n } from '@whizz/react-i18n';
import type { ClassReportType, HighlightedProps } from '../../types';
import { SectionLayout } from '../modules';
import { StudentProgress } from '../../../components';

type Props = {
  classReport: ClassReportType;
  showOthersData: boolean
  hideAverage?: boolean
  chartIsExpanded?: boolean
} & HighlightedProps;

const Progressions = ({
  classReport,
  showOthersData,
  highlightedLabel,
  highlightedIds,
  hideAverage,
  chartIsExpanded,
  onElementClick,
}: Props): JSX.Element => {
  const { translate } = useI18n();

  const getHeaderValue = (decimal = '.0f'): string => {
    let studentListWithZeroMathsAgeRemoved = classReport.students.all.filter((student) => student.chartsData.mathsAge > 0);
    if (highlightedLabel) {
      studentListWithZeroMathsAgeRemoved = studentListWithZeroMathsAgeRemoved.filter((student) => highlightedIds.includes(student.id));
    }
    const mean = d3.mean(studentListWithZeroMathsAgeRemoved.map((student) => student.chartsData.progression));
    return mean != undefined ? d3.format(decimal)(mean) : '';
  };

  const value = classReport.progressionAverage.toFixed(2);
  const highlightValue = getHeaderValue('.2f');

  return (
    <SectionLayout
      title={translate('pages.REPORTS.SECTIONS.PROGRESSIONS.title')}
      value={showOthersData ? value : null}
      highlightLabel={highlightedLabel}
      highlightValue={highlightValue}
      description={translate('pages.REPORTS.SECTIONS.PROGRESSIONS.description')}
      moreInfo={translate('pages.REPORTS.SECTIONS.PROGRESSIONS.info')}
      className={'pdf-no-break'}
      data-cy="progressions"
      hideAverage={hideAverage}
      chartIsExpanded={chartIsExpanded}
      id='progressions-container'
    >
      <StudentProgress
        showOthersData={showOthersData}
        data={classReport.students.all ?? []}
        chartType={'progression'}
        highlightedIds={highlightedIds}
        removeUnassessed={true}
        onElementClick={onElementClick}
      />
    </SectionLayout>
  );
};

Progressions.displayName = 'Progressions';

export default Progressions;
